import { BrowserRouter, HashRouter } from "react-router-dom";
import AdminRouter from "./adminRouter.jsx";

const Router = () => {
  return (
    <HashRouter>
      <AdminRouter />
    </HashRouter>
  );
};

export default Router;
